import { css } from 'lit';

export const styles = [
  css`
    :host {
      --default-rem-px-count: 16;
      --column-gap: calc(32rem / var(--default-rem-px-count));
    }

    .header {
      padding-bottom: calc(42rem / var(--default-rem-px-count));
    }

    h1 {
      font-size: calc(32rem / var(--default-rem-px-count));
      font-weight: 500;
      letter-spacing: -1.12;
      line-height: calc(40rem / var(--default-rem-px-count));
    }

    h4 {
      font-size: calc(24rem / var(--default-rem-px-count));
      font-weight: 500;
      letter-spacing: -0.54;
      line-height: calc(24rem / var(--default-rem-px-count));
    }

    .page-wrapper {
      margin: 0 auto;
      max-width: 1440px;
      padding: 2rem 1rem;
      display: flex;
      flex-direction: column;
    }

    .content-wrapper {
      display: flex;
      flex-direction: column;
    }

    .location-wrapper {
    }

    .location-wrapper {
      border: 2px solid #000;
      display: flex;
      flex-direction: column;
      max-width: 100%;
      padding: calc(16rem / var(--default-rem-px-count));
      margin-bottom: calc(12rem / var(--default-rem-px-count));
    }

    h4 {
      padding-bottom: calc(24rem / var(--default-rem-px-count));
      margin: 0;
    }

    p {
      margin: calc(6rem / var(--default-rem-px-count)) 0;
    }

    .added-padding {
      padding: calc(20rem / var(--default-rem-px-count)) 0;
    }

    .description {
      padding-bottom: calc(20rem / var(--default-rem-px-count));
    }

    .row {
      gap: calc(14rem / var(--default-rem-px-count));
      display: grid;
      width: 100%;
      grid-template-columns: 1fr 3fr;

      .descriptor {
        font-weight: 500;
        grid-column: 1;
        grid-row: 1;
      }

      .value {
        grid-column: 2 / 5;
        grid-row: 1;
      }
    }

    @media (min-width: 600px) {
      .page-wrapper {
        padding: 3rem 2rem;
      }

      .content-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: calc(24rem / var(--default-rem-px-count));
      }

      .location-wrapper {
        padding: calc(16rem / var(--default-rem-px-count))
          calc(20rem / var(--default-rem-px-count));
        width: calc(350rem / var(--default-rem-px-count));
        aspect-ratio: 3/2;
      }
    }

    @media (min-width: 1024px) {
      .content-wrapper {
        flex-direction: row;
        gap: calc(48rem / var(--default-rem-px-count));
      }

      .location-wrapper {
        padding: calc(32rem / var(--default-rem-px-count));
        width: calc(30% - (3 * calc(24rem / var(--default-rem-px-count))));
        min-width: calc(345rem / var(--default-rem-px-count));
      }
    }
  `,
];
